// extracted by mini-css-extract-plugin
export default {"l":"a69a92bc9a"};